import { IField } from "../interfaces/inputs/IField";
import { Endpoints } from "../utils/Endpoints";
import { getForms } from "../utils/Helpers";

const campuses = [
  {value: 'gha-nur-buwaate', text: 'Buwaate Nursery'},
  {value: 'gha-buwaate', text: 'Buwaate'},
  {value: 'gha-nur-kibuli', text: 'Kibuli Nursery'},
  {value: 'gha-primary', text: 'Kibuli Primary'},
  {value: 'gha-secondary', text: 'Kibuli Secondary'}
]

const terms = [
  {value: 'I', text: 'I'},
  {value: 'II', text: 'II'},
  {value: 'III', text: 'III'}
]

export const CalendarFields: IField[] = [
  { name: "campus", type: "select", label: "Campus", options: campuses, size: {lg: 3}, position: 1 },
  { name: "form", type: "select", label: "Class", options: getForms(), size: {lg: 3}, position: 2 },
  { name: "term", type: "select", label: "Term", options: terms, position: 3, size: {lg: 3} },
  { name: "year", type: "number", label: "Year", size: {lg: 3}, position: 4 },
  { name: "start_date_time", type: "datetime", label: "Start Date & Time (yyyy-mm-dd HH:MM)", size: {lg: 6}, position: 5 },
  { name: "end_date_time", type: "datetime", label: "End Date & Time (yyyy-mm-dd HH:MM)", size: {lg: 6}, position: 6 },
  { name: "title", type: "text", label: "Title", size: {lg: 12}, position: 7 },
  { name: "details", type: "textarea", label: "Details", size: {lg: 12}, position: 8 },
].sort((a: IField, b: IField) => a.position - b.position);